module.exports = __webpack_public_path__ + "images/5bf4d20ce24900de37a0eb55b8c558b0.png";